import { select, Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SchoolSearchCriteria } from '../../scp/search/models/school-search-criteria.model';
import { states } from '../../scp/scp-common/models/states';
import * as fromStore from '../../reports/store';

import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'opus-reports-school-search',
  templateUrl: './reports-school-search.component.html',
})

export class ReportsSchoolSearchComponent implements OnInit {
  hasSubmitted: boolean;
  searchForm: FormGroup;
  states: string[] = states;
  schoolLevels: { [name: string]: number; } = {
    'ELEMENTARY': 1,
    'MIDDLE': 2,
    'HIGH': 3,
    'COLLEGE': 4,
    'OTHER': 5
  };

  schoolSearchState$: Observable<fromStore.ReportsSchoolSearchState>;

  private _subscription: Subscription;
  private _schoolSearchCriteria: SchoolSearchCriteria;

  constructor(private formBuilder: FormBuilder, private _store: Store<fromStore.ReportsSearchState>) { }

  ngOnInit() {
    const numberValidator = Validators.pattern(/^\s*[0-9]*\s*$/);
    const zipValidator = Validators.pattern(/^\d{5}(-\d{4})?$/);

    // Grab the current district search criteria state
    this.schoolSearchState$ = this._store.pipe(select(fromStore.getReportsSchoolSearchState));
    console.log(this.schoolSearchState$);
    this._subscription = this.schoolSearchState$.subscribe(s => {
      return this._schoolSearchCriteria = s.searchCriteria;
    });

    this.searchForm = this.formBuilder.group({
      code: [this._schoolSearchCriteria.code, numberValidator],
      county: this._schoolSearchCriteria.county == null ? [''] : [this.stripEncoding(this._schoolSearchCriteria.county)],
      districtId: [this._schoolSearchCriteria.districtId, numberValidator],
      districtName: this._schoolSearchCriteria.districtName == null ? [''] : [this.stripEncoding(this._schoolSearchCriteria.districtName)],
      gradeLevel: this._schoolSearchCriteria.gradeLevel == null ? ['Any'] : [this._schoolSearchCriteria.gradeLevel],
      id: [this._schoolSearchCriteria.id, numberValidator],
      isActive: this._schoolSearchCriteria.isActive == null ? ['true'] : [this._schoolSearchCriteria.isActive],
      longName: this._schoolSearchCriteria.longName == null ? [''] : [this.stripEncoding(this._schoolSearchCriteria.longName)],
      radius: [this._schoolSearchCriteria.radius],
      state: this._schoolSearchCriteria.state == null ? ['Any'] : [this._schoolSearchCriteria.state],
      zip: [this._schoolSearchCriteria.zip, zipValidator],
    });
  }

  stripEncoding(str: string): string {
    str = str.replace(/%20/g, " ");
    return str;
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }


  onSubmit() {
    if (!this.searchForm.valid) {
      // Form is not legit, don't submit!
      return;
    }

    // Our query we'll fill in later
    const schoolSearchCriteria: SchoolSearchCriteria = {
      id: null,
      longName: null,
      districtId: null,
      districtName: null,
      county: null,
      state: null,
      zip: null,
      radius: null,
      phone: null,
      code: null,
      primaryFulfillmentSite: null,
      schoolType: null,
      gradeLevel: null,
      callDay: null,
      isActive: null,
      offersBandshare: null
    };

    Object.keys(this.searchForm.controls).forEach(key => {
      const value = this.searchForm.get(key).value;
      const valueAsString = String(value).trim();
      // If item has a value...
      if (value !== null && value !== '') {
        // If it's one of these keys and value is "Any"
        const anyKeys = ['state', 'schoolType', 'gradeLevel', 'callDay', 'isActive', 'offersBandshare'];
        if (anyKeys.some(i => i === key) && value == 'Any') {
          // Treat "any" like null.
          return;
        }
        // Else, add it to query string
        else {
          schoolSearchCriteria[key] = valueAsString;
        }
      }
    });

    this.hasSubmitted = true;
    this._store.dispatch(new fromStore.ExecuteReportsSchoolSearch(schoolSearchCriteria));
  }
}
